import Message from "../models/Messages/Message";

export class SocketMessageReceiver {
    socket = null;
    store = null

    /**
     * @param socket {WebSocket}
     * @param store {Store}
     */
    constructor(socket, store) {
        this.socket = socket;
        this.store = store;
        this.socket.onmessage = (event) => {
            const data = JSON.parse(event.data || '');
            if (data && data[0]) {
                const eventType = data[0];
                if (typeof this[eventType] == 'function') {
                    this[eventType](data[1]);
                }
            }
        };
    }

    addMessageToSelected(message) {
        if (this.store.state.chat.room.instance && this.store.state.chat.room.instance.id == message.roomID) {
            this.store.dispatch('chat/room/newMessage', message);
        }
    }

    async newMessage(data) {
        const message = new Message(data);
        this.addMessageToSelected(message);
        await this.store.dispatch('chat/rooms/setLastMessage', message);
        this.store.dispatch('chat/showNotification', message);
    }

    async newUser(data) {
        const message = new Message(data);
        this.addMessageToSelected(message);
        await this.store.dispatch('chat/rooms/setLastMessage', message);
        this.store.dispatch('chat/showNotification', message);
    }

    async userLeft(data) {
        const message = new Message(data);
        this.addMessageToSelected(message);
        const room = this.store.getters['chat/rooms/roomById'](message.roomID);
        await this.store.dispatch('chat/rooms/setLastMessage', message);
        message.room = room;
        this.store.dispatch('chat/showNotification', message);
    }

    sendTyping(data) {

    }
}
